import script from "./ResponsiveVideoEmbed.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsiveVideoEmbed.vue?vue&type=script&setup=true&lang=js"

import "./ResponsiveVideoEmbed.vue?vue&type=style&index=0&id=4d7f55eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d7f55eb"]])

export default __exports__